module.exports = __webpack_public_path__ + "img/zaymekspress.3e20207f.svg";